module.exports = __webpack_public_path__ + "media/fenghuang.a88201e0.mp3";